require("../css/style.less");
require("../css/style.scss");
require("bootstrap");

document.Artist = require("./artist");
document.Charts = require("./charts");